import {stores} from "../stores";
// import {getConfigurationParamById} from "../model";

//TODO: delete me
/*
export function configParamClass(paramID: string) {
    const param = getConfigurationParamById(paramID);
    if (param) {
        return `${stores.model.isConfigValueDirty(param.offset) ? 'dirty' : ''} ${stores.model.isConfigValueSaved(param.offset) ? 'saved' : ''}`;
    } else {
        console.warn("configParamClass: param not found", paramID)
        return '';
    }
}
*/

//TODO: delete me
/*
export function presetParamClass(index: number, paramID: string) {
    return `${stores.model.isPresetParamDirty(index, paramID) ? 'dirty' : ''} ${stores.model.isPresetParamSaved(index, paramID) ? 'saved' : ''}`;
}
*/


export function getGlobalParameterStateStyle(parameterId: string) {
    // console.log("globalParameterStateStyle", parameterId, stores.memory.globalStates[parameterId]);
    // const param = getConfigurationParamById(parameterId);
    // if (param) {
        return `${stores.memory.isGlobalParamDirty(parameterId) ? 'dirty' : ''} ${stores.memory.isGlobalParamSaved(parameterId) ? 'saved' : ''}`;
    // } else {
    //     console.warn("configParamClass: param not found", parameterId)
    //     return '';
    // }
}


export function getPresetParameterStateStyle(parameterId: string, presetNumber: number) {
    return `${stores.memory.isPresetParamDirty(parameterId, presetNumber) ? 'dirty' : ''} ${stores.memory.isPresetParamSaved(parameterId, presetNumber) ? 'saved' : ''}`;
}

/**
 * Returns the displayed preset number based on the PRESET_OFFSET global parameter
 * 
 * @param actualPresetNumber - The actual preset number (0-99)
 * @returns The displayed preset number (0-99 or 1-100 depending on setting)
 */
export function getDisplayPresetNumber(actualPresetNumber: number): number {
  // Check if PRESET_OFFSET is set to 1 (1-100 display mode)
  const useOffset = stores.memory.getGlobalParamValue("PRESET_OFFSET") === 1;
  
  // If offset is enabled, add 1 to the displayed number
  return useOffset ? actualPresetNumber + 1 : actualPresetNumber;
}

/**
 * Converts a displayed preset number back to the actual preset number
 * This is useful when accepting user input that might be in the display format
 * 
 * @param displayedNumber - The displayed preset number (possibly 1-100)
 * @returns The actual preset number (0-99)
 */
export function getActualPresetNumber(displayedNumber: number): number {
  // Check if PRESET_OFFSET is set to 1 (1-100 display mode)
  const useOffset = stores.memory.getGlobalParamValue("PRESET_OFFSET") === 1;
  
  // If offset is enabled, subtract 1 to get the actual preset number
  return useOffset ? Math.max(0, displayedNumber - 1) : displayedNumber;
}